<template>
    <div>
        <div class="user_right">
            <h1 class="urs_h1">我的订单</h1>
            <div class="fv_top">
                <a class="fv_tli " href="javascript:;" @click="$router.push({path: '/user_order', query:{status:0,showVideo:1,}})">全部</a>
                <a class="fv_tli " href="javascript:;" @click="$router.push({path: '/weifukuan', query:{status:'未支付',showVideo:1,}})">待付款</a>
                <a class="fv_tli " href="javascript:;" @click="$router.push({path: '/weishouhuo', query:{status:'已发货',showVideo:1,}})">待收货</a>
                <a class="fv_tli " href="javascript:;" @click="$router.push({path: '/weifahuo', query:{status:'已支付',showVideo:1,}})">待发货</a>
                <a class="fv_tli fv_ton" href="javascript:;" @click="$router.push({path: '/weipingjia', query:{status:'待评价',showVideo:1,}})">待评价</a>
            </div>
            <p class="pd15 c9">防诈骗提示：夜樱情趣商城不会以任何理由发送连接要求您填写银行信息，谨防假冒客服电话诈骗</p>
            <public-nothing v-if="tableData.data == []"></public-nothing>
            <div class="order_list" id="glist" v-else>
                <div class="od_lst" v-for="(item,index) in tableData.data" :key="index">
                    <p class="od_t">
                        <em class="left">订单号:{{item.oid}}</em>
                        <em class="od_s">{{item.status}}</em>
                    </p>
                    <div class="od_gl" v-for="(iops,ind) in item.iop" :key="ind">
                        <a href="javascript:;" @click="$router.push({path: '/order_detail', query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})" class="">
                            <img :src="iops.piclink" class="od_mg">
                            <p class="od_na">{{iops.title}}</p>
                            <p class="od_atr">{{iops.sku_cn}}</p>
                        </a>
                        <p class="od_r">
                            <em class="c3 f10">¥</em>
                            <em class="c3">{{$fnc.toFixedZ(iops.money)}}</em>
                            <em class="c9">x{{iops.number}}</em>
                        </p>
                    </div>
                    
                    <p class="od_ftt">微信支付,共{{item.number}}件商品,合计:¥{{$fnc.toFixedZ(item.money)}}</p>
                    <div class="od_ft">
                        <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_review',query:{id:orderId,oid:item.oid,showVideo:1,uid:item.uid}})" v-if=" item.status == '已完成' && (pro_status == 0 || pro_status == '0') && item.types != 25 ">{{item.is_review == 0 ? "待评价" : "已评价" }}</a>
                        <!-- <a class="od_btn od_btnr" href="javascript:;" @click="$router.push({path: '/order_review', query:{id:orderId,oid:item.oid,showVideo:1,uid:item.uid}})" v-if="item.status=='已完成'">待评价</a> -->
                        <!-- <a class="od_btn" href="javascript:;" @click="$router.push({path: '/order_detail', query:{id:item.id,oid:item.oid,showVideo:1,uid:item.uid}})">详情</a> -->
                    </div>
                </div>
            </div>
            <div class="page" id="pager">
                <el-pagination :page-sizes="[12,24,36,48]" :page-size="tableFrom.limit" :current-page="tableFrom.page" layout="total, sizes, prev, pager, next, jumper" :total="tableData.total" @size-change="handleSizeChange" @current-change="pageChange" />
            </div>
        </div>
    </div>
</template>

<script>
import Public_nothing from "@/components/order/no_order"
export default {
    components:{
        'public-nothing': Public_nothing,
    },
    data(){
        return{
            numa:1,
            list:[],
            is_friend: 0,
            status:"待评价",
            tableData: {
                data: [],
                total: 0,
            },
            listLoading: true,
            LogLoading: false,
            dialogVisible: false,

            tableFrom: {
                page: 1,
                page_size: 10,
                status:"待评价",
                type:"",
                is_friend: 0,
                id:JSON.parse(window.localStorage.getItem("user")).id ? JSON.parse(window.localStorage.getItem("user")).id : "",
            },
            orderRefund:"",
            pro_status:"",
            orderId:"",
        }
    },
    mounted(){
        this.getList(1);
        this.getOrderList(JSON.parse(window.localStorage.getItem("user")).id);
    },
    methods:{
        getOrderList(id) {
            var params = {};
            params.id = id || "";
            params.is_friend = this.is_friend;
            params.status = this.$route.query.status || "";
            if (this.$route.query.mid && this.$route.query.mid != "") {
                params.is_mid = 1;
            }
            this.dialogVisible = true;
            this.LogLoading = true;
            this.$api.getOrder.getOrderLists(params).then(res => {
                if (res.code == 200) {
                    this.tableData.data = res.result.data;
                    var arr = res.result.data[0].product;
                    // arr.forEach((item,i) => {
                    //     console.log(item)
                        arr.forEach((n,m)=>{
                            this.orderId = n.id;
                            this.orderRefund = n.order_return;
                            this.pro_status = n.status;
                        })
                    // });
                    console.log(this.pro_status)
                    this.tableData.total = res.result.count  // 总条目数
                    this.tableData.page = res.result.page;
                    this.tableData.page_size = res.result.pageSize;
                    this.listLoading = false;
                }
            });
        },
        //列表
        getList(num) {
            this.listLoading = true;
            this.tableFrom.page = num ? num : this.tableFrom.page;
            this.$api.getOrder.getOrderLists(this.tableFrom).then((res) => {
                
                if (res.code == 200) {
                    this.tableData.data = res.result.data;
                    this.tableData.total = res.result.count  // 总条目数
                    this.tableData.page = res.result.page;
                    this.tableData.page_size = res.result.pageSize;
                    this.tableData.id = JSON.parse(window.localStorage.getItem("user")).id;
                    this.listLoading = false;
                }
            }).catch((res) => {
                this.$message.error(res.message);
                this.listLoading = false;
            });
        },
        pageChange(page) {
            this.tableFrom.page = page;
            this.getList('');
        },
        handleSizeChange(val) {
            this.tableFrom.limit = val;
            this.getList('');
        },
    },
}
</script>

<style scoped>
@import url('../../assets/css/user.css');
</style>


// WEBPACK FOOTER //
// src/components/order/weipingjia.vue